// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__EH8dC","cell":"ColumnAccessor_cell__1di6n","firstCellAccent":"ColumnAccessor_firstCellAccent__30NKP"};